import {Component, inject, OnInit} from '@angular/core';
import {DatePipe} from '@angular/common';
import {RouterLink} from '@angular/router';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import {MetasService} from '../../../../core/services/meta-service/metas.service';
import {getSEOMetaData} from '../../../../core/constants/seo.constants';

@Component({
  selector: 'app-terms-page',
  imports: [
    DatePipe,
    RouterLink,
    TranslatePipe
  ],
  templateUrl: './terms-page.html',
  styles: ``
})
export class TermsPage implements OnInit {
  #metasService: MetasService = inject(MetasService);
  #translateService: TranslateService = inject(TranslateService);
  
  lastUpdateDate: Date = new Date(2025, 1, 18);

  async ngOnInit(): Promise<void> {
    // Update SEO meta tags
    const metaData = getSEOMetaData('terms');
    if (metaData) {
      await this.#metasService.updateMetaTags(metaData);
    }
    
    // Update language attribute
    const currentLang = this.#translateService.currentLang || 'en';
    this.#metasService.updateLanguage(currentLang);
  }
}
